<template>
	<div
		id="journey-details"
		class="bg-white px-6 py-8 xl:px-12 xl:py-10 lg:col-span-2 relative"
	>
		<h3>Journey Details</h3>
		<div class="mt-8 grid grid-cols-2 gap-6 md:flex md:gap-20 xl:gap-28">
			<div v-if="journey.vessel.length">
				<p class="mb-1 lg:text-sm lg:mb-2">Vessel</p>
				<h5 class="lg:text-9xl">{{ journey.vessel }}</h5>
			</div>
			<div
				v-if="journey.duration.length"
				class="col-span-2 flex items-center gap-4 md:block"
			>
				<p class="mb-0 lg:text-sm lg:mb-2">Estimated time</p>
				<h5 class="lg:text-9xl">{{ journey.duration }}</h5>
			</div>
		</div>

		<!-- Add this back in if we can get ports to work or not -->
		<div
			class="mt-10 px-4 xl:mt-14 xl:flex xl:flex-wrap md:px-0"
			:class="[{ 'xl:justify-between': journey.legs.length <= 4 }]"
		>
			<div
				:class="[
					{
						'before:absolute before:left-0 before:top-0 before:h-full before:w-[1px] before:bg-black xl:before:w-full xl:before:h-[1px] xl:pl-0 xl:pb-0 xl:pr-16 ':
							index !== journey.legs.length - 1,
						'xl:w-1/4 xl:mb-10': journey.legs.length > 4,
						'xl:flex-1': journey.legs.length <= 4,
					},
					'port-item relative w-full pl-8 pb-10 xl:pt-10 xl:pl-0',
				]"
				v-for="(leg, index) in journey.legs"
				:key="index"
			>
				<span
					class="absolute left-[-14px] top-[-3px] rounded-full bg-red w-7 h-7 flex items-center justify-center font-heading text-white !leading-4 xl:top-[-14px] xl:left-0"
					aria-label="Port {{ index + 1 }}"
				>
					{{ index + 1 }}
				</span>
				<div class="mb-2 flex items-center gap-x-4">
					<h4 class="!leading-4">{{ leg.port }}</h4>
				</div>
				<div>
					<p class="text-sm">Voyage No: {{ leg.voyage }}</p>
					<p
						:class="[
							index === journey.legs.length - 1 ? 'text-red' : 'text-gray-dark',
							'port-arrivals port-icon lg:text-sm mb-1',
						]"
						v-if="leg.arrivalTime && index !== 0"
					>
						Expected to Arrive {{ leg.arrivalTime }}
					</p>
					<p
						:class="[
							index === 0 ? 'text-red' : 'text-gray-dark',
							'port-departure port-icon lg:text-sm mb-1',
						]"
						v-if="leg.departureTime && index !== journey.legs.length - 1"
					>
						Expected to Depart {{ leg.departureTime }}
					</p>
					<p
						class="mt-6"
						v-if="
							index === 1 &&
							index === journey.legs.length &&
							leg.transhipmentDuration
						"
					>
						<span
							class="rounded-full border border-blue pt-2 pb-2 px-4 lg:text-sm"
						>
							Transhipment {{ leg.transhipmentDuration }}
						</span>
					</p>
				</div>
			</div>
		</div>

		<!-- End of Block-->
		<div
			v-if="dateInFuture"
			class="mt-6 md:mt-0 md:absolute md:right-12 md:top-10"
		>
			<a
				:href="'/request-a-rate' + scheduleUrl"
				class="button w-full justify-between"
			>
				Request a rate
				<span class="w-3 h-3 md:ml-6">
					<svg
						class="w-full h-full fill-inherit"
						xmlns="http://www.w3.org/2000/svg"
						viewBox="0 0 200 200"
					>
						<polygon
							fill-rule="evenodd"
							clip-rule="evenodd"
							points="66.7,32.6 66.8,51.9 134.5,51.9 32.6,153.7 46.3,167.4 148.1,65.5 148.1,133.2 167.4,133.3 167.4,42.3 167.4,32.6 157.7,32.6 "
						/>
					</svg>
				</span>
			</a>
		</div>
	</div>
</template>

<script>
import axios from "axios";
import { polyfill } from "smoothscroll-polyfill";

/**
        title: Journey Details
        props: {
            - journey: Get the Chosen Journey from the parent
        }
        mounted: {
            - function: Scroll down to the journey when selected
        }
		computed: {
			- scheduleUrl: This creates the url for the request from the journey data.
		}
    **/
export default {
	props: ["journey"],
	mounted: function () {
		this.$nextTick(function () {
			// Scroll User to the journey once it displays
			const formContainer =
				document.querySelector("#journey-details").offsetTop - 50;

			// Add the polyfill so Scroll will work on Safari
			polyfill();

			scroll({
				top: formContainer,
				behavior: "smooth",
			});
		});
	},
	computed: {
		dateInFuture: function () {
			const leaveTime = new Date(this.journey.leaveTime);
			const today = new Date();

			if (leaveTime > today) {
				return true;
			} else {
				return false;
			}
		},
		scheduleUrl: function () {
			// `this` points to the vm instance
			const departure = "shippingDeparture=" + this.journey.firstLeg;
			const arrival = "shippingArrivals=" + this.journey.lastLeg;
			const date = "shippingDate=" + this.journey.leaveTime;

			return "?" + departure + "&" + arrival + "&" + date;
		},
	},
};
</script>
